<template>
    <div>

        <el-card>

            <div slot="header">
                <router-link :to="{ path:'/systemFeishuPersonUpdata', query:{callback: request }}">
                    <el-button type="primary">新增</el-button>
                </router-link>
            </div>

        </el-card>

        <el-card>

            <el-table :data="tableData" row-key="index" lazy :load="load" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" v-loading='loading'>

                <el-table-column type="index" width="50"></el-table-column>

                <el-table-column label="组织机构名称" prop="name"></el-table-column>

                <el-table-column label="操作" fixed="right">

                    <template slot-scope="scope" >

                        <router-link :to="{ path: '/systemFeishuUser', query:{ id: scope.row.id, type: scope.row.type, callback: request }}">
                            <el-button type="text" >用户</el-button>
                        </router-link>

                        <router-link :to="{ path:'/systemFeishuPersonUpdata', query:{ row: scope.row, type:'edit',  callback: request }}" v-if="scope.row.type !== 'department'">
                            <el-button type="text">编辑</el-button>
                        </router-link>

                        <el-button v-w-role="'ITSM-0076-F'" class="table-del-btn" type="text" @click="deleteRole(scope.row.type, scope.row.id)" v-if="scope.row.type !== 'department'">删除</el-button>

                    </template>

                </el-table-column>

            </el-table>

        </el-card>

    </div>
</template>

<script>
    import services from './system.services'

    export default {

        data() {
            return {
                loading: true,
                tableData: [],
                form: {}
            }
        },

        mounted() {
            this.request()
        },

        methods: {

        // 树叶子请求
        load(tree, treeNode, resolve) {
            services.treeChildren({departmentId: tree.id, type: tree.type })
                .then(res => {
                    let newArr = res.list.map(item => ({ ...item, hasChildren: item.children, flag: true}))
                    // console.log(newArr)
                    resolve(newArr)
                })
        },

        // 请求数据
        request() {
            services.treeTop()
                .then(res => {
                    this.tableData = res.list.map(item => ({ ...item, hasChildren: item.children, flag: false }))
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },

            // 删除某一项
            deleteRole(type, id) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        if (type === 'group') {
                            services.groupDelete({groupId: id})
                                .then(res => {
                                    this.$message.success('删除成功!')
                                    //子节点删除后刷新整个组件，跳转空白页再跳回来
                                    this.$router.push({
                                        path:'/redirect',
                                        query:{
                                            url:'/systemFeishuPerson'
                                        }
                                    })
                                })
                                .catch(err => this.$message.error(err.message))
                        } else {
                            services.departmentDelete({departmentId: id})
                                .then(res => {
                                    this.$message.success('删除成功!')
                                    this.$router.push({
                                        path:'/redirect',
                                        query:{
                                            url:'/systemFeishuPerson'
                                        }
                                    })
                                })
                                .catch(err => this.$message.error(err.message))
                        }
                    })
                    .catch(() => this.$message.info('已取消删除'))
            }
        }



}
</script>

<style lang="scss" scoped>

</style>
